import { render, staticRenderFns } from "./BillingDocumentFilePreview.vue?vue&type=template&id=18704e50&scoped=true"
import script from "./BillingDocumentFilePreview.vue?vue&type=script&lang=js"
export * from "./BillingDocumentFilePreview.vue?vue&type=script&lang=js"
import style0 from "./BillingDocumentFilePreview.vue?vue&type=style&index=0&id=18704e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18704e50",
  null
  
)

export default component.exports